<template>
  <el-card
    class="background"
    v-loading="loading"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="merchant-overview">
      <SiruiSearch
        ref="searchRef"
        :query="queryData"
        :columns="topColumns"
        :isQueryPanel="true"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchTrigger"
        @changeMethod="changeMethod"
      ></SiruiSearch>
      <div class="result-table">
        <sirui-table
          ref="siruiTable"
          :buttonList="menuButtonList"
          @chooseClick="chooseClick"
          :loading="loading"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="() => getTableData()"
          @handleCurrentChange="() => getTableData()"
          :cellStyle="cellStyle"
          :cellClick="cellClick"
          :data="tableData"
          :paging="true"
          :setting="false"
          :customVisible="false"
          :columns="tableColumns"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in tableColumns"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
            :field="item.field"
            :title="item.title ? $t(item.title) : null"
            :visible="item.visible"
            :type="item.type"
            :width="item.width"
          >
            <template slot-scope="scope">
              <span v-if="item.field == 'relatedContractStatus'">
                {{ getStatusName('contract', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'nicheStatus'">
                {{ getStatusName('niche', scope.row[item.field]) }}</span
              >
              <span v-else-if="item.field == 'entryStatus'">
                {{ getStatusName('entry', scope.row[item.field]) }}</span
              >
              <span v-else>{{ scope.row[item.field] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <MerchantSettleDialog
        ref="settleDialogRef"
        @handleSure="() => getTableData()"
      ></MerchantSettleDialog>
      <MerchantRelateContractDialog
        ref="relateContractDialogRef"
        @handleSure="() => getTableData()"
      ></MerchantRelateContractDialog>
    </div>
  </el-card>
</template>

<script>
  import SiruiSearch from '@/components/SiruiSearch';
  import { searchColumns, defaultTableColumns } from './columns';
  import MerchantSettleDialog from './dialogs/MerchantSettleDialog.vue';
  import MerchantRelateContractDialog from '@/pages/property/merchants/merchantCenter/overview/dialogs/MerchantRelateContractDialog.vue';
  import MerchantOverviewMixin from '@/pages/property/merchants/merchantCenter/overview/MerchantOverviewMixin';
  export default {
    name: 'MerchantOverview',
    mixins: [MerchantOverviewMixin],
    components: {
      SiruiSearch,
      MerchantSettleDialog,
      MerchantRelateContractDialog,
    },
    mounted() {
      this.queryData.nicheCompanyNo = this.userInfo.companyCode;
      // this.queryData.nicheDepartmentCode = this.userInfo.departmentCode;
      this.$refs.siruiTable.setPageSize(10);
      this.getTableData();
      this.getButtonList();
      this.getDepartmentList(this.userInfo.companyCode);
    },
    data() {
      return {
        loading: false,
        tableColumns: [],
        menuButtonList: [], // 表格功能按钮
      };
    },
    computed: {
      topColumns() {
        return searchColumns(this);
      },
    },
    methods: {
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.selectedItems = [];
        this.queryData = {
          nicheCompanyNo: this.userInfo.companyCode,
          nicheDepartmentCode: '',
        };
        this.getTableData();
      },
      handleSelectionChange(row) {
        this.selectedItems = row;
        console.log(row);
      },
      // 搜索
      searchTrigger() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },

      // 表格上面的按钮
      async chooseClick(type) {
        console.log(this.selectedItems);
        let empty = !this.selectedItems || !this.selectedItems.length;
        let justOne = this.selectedItems.length == 1;
        let item = this.selectedItems[0];

        let entryStatus = this.getStatusName('entry', item?.entryStatus);
        let nicheStatus = this.getStatusName('niche', item?.nicheStatus);
        let contractStatus = this.getStatusName('contract', item?.relatedContractStatus);

        console.log('click', type);

        console.log('selectionStatus', entryStatus, nicheStatus, contractStatus);

        if (empty && type != 'create' && type != 'export') {
          this.$message.error('请选择数据！');
          return;
        }
        if (!justOne && type != 'create' && type != 'export') {
          this.$message.error('请选择一条数据！');
          return;
        }

        switch (type) {
          case 'export':
            this.handleExport(this.selectedItems);
            break;
          case 'create':
            this.toDetailPage(0, null);
            break;
          case 'edit':
            if (nicheStatus != '待签约') {
              this.$message.error('该状态的数据不支持编辑，请核实！');
              return;
            }
            this.toDetailPage(2, item.id);

            break;
          case 'signContract':
            if (nicheStatus != '待签约') {
              this.$message.error('该状态的数据不支持签订合同，请核实！');
              return;
            }
            this.toSignContract(item);
            //fixme需要对接租赁合同
            break;
          case 'relateContract':
            if (nicheStatus != '待签约') {
              this.$message.error('该状态的数据不支持关联合同，请核实！');
              return;
            }

            this.$refs.relateContractDialogRef.openDialog(item);
            break;
          case 'join':
            if (nicheStatus != '已签约' || contractStatus != '生效中' || entryStatus != '待入驻') {
              this.$message.error('该状态的数据不支持商户入驻，请核实！');
              return;
            }
            //fixme需要先关联合同
            this.$refs.settleDialogRef.openDialog(item.id);
            break;
          case 'close':
            if (nicheStatus != '待签约') {
              this.$message.error('该状态的数据不支持关闭，请核实！');
              return;
            }
            this.closeNiche(item.id);
            break;
          default:
            break;
        }
      },
      cellClick(val) {
        if (val.column?.property == 'nicheNo') {
          this.toDetailPage(1, val.row.id);
        } else if (val.column?.property == 'relatedContractNo') {
          console.log('clickContract', val);
          this.toLeaseContractDetail(val.row.relatedContractId);
        }
      },
      cellStyle({ column }) {
        if (column.property == 'nicheNo' || column.property == 'relatedContractNo') {
          // console.log('cellStyle', row, rowIndex, column, columnIndex);
          return {
            color: '#009fcc',
          };
        }
      },
      //获取当前列数据
      getColumnInfo() {
        this.getColumnList(defaultTableColumns()).then(() => {
          this.tableColumns = defaultTableColumns();
        });
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          console.log('menuButtons', this.menuButtonList);
          this.getColumnInfo();
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
